import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, Phone, MapPin, Mail } from 'lucide-react';
import { toast } from 'sonner';
export function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    const form = e.currentTarget;
    const formData = new FormData(form);
    const data = {
      nombre: formData.get('nombre'),
      email: formData.get('email'),
      telefono: formData.get('telefono'),
      tipoServicio: formData.get('tipoServicio'),
      ciudad: formData.get('ciudad')
    };
    try {
      const response = await fetch('https://hook.us2.make.com/xhdrdc70xmvn8xrbjlecr9ik14pj3rge', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        toast.success('¡Solicitud enviada con éxito! Nos pondremos en contacto pronto.');
        form.reset();
      } else {
        throw new Error('Error en la respuesta del servidor');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Hubo un problema al enviar su solicitud. Por favor, intente nuevamente o contáctenos por WhatsApp.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="contacto" className="py-20 bg-white" data-id="element-50">
      <div className="container mx-auto px-4 md:px-6" data-id="element-51">
        <div className="flex flex-col lg:flex-row gap-16" data-id="element-52">
          {/* Contact Info */}
          <div className="w-full lg:w-5/12" data-id="element-53">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-54">
              <h2 className="text-pool-600 font-semibold tracking-wider uppercase text-sm mb-2" data-id="element-55">
                Contacto
              </h2>
              <h3 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-56">
                Agende su Inspección Gratuita
              </h3>
              <p className="text-gray-600 mb-10 text-lg" data-id="element-57">
                Complete el formulario y uno de nuestros expertos se pondrá en
                contacto con usted para programar una visita sin compromiso.
              </p>

              <div className="space-y-8" data-id="element-58">
                <div className="flex items-start gap-4" data-id="element-59">
                  <div className="w-12 h-12 rounded-full bg-pool-50 flex items-center justify-center text-pool-600 flex-shrink-0" data-id="element-60">
                    <Phone size={24} data-id="element-61" />
                  </div>
                  <div data-id="element-62">
                    <h4 className="font-bold text-navy-900 text-lg" data-id="element-63">
                      Llámenos o WhatsApp
                    </h4>
                    <a href="https://wa.me/16893266071" target="_blank" rel="noreferrer" className="text-gray-600 hover:text-pool-600 transition-colors text-lg" data-id="element-64">
                      +1 (689) 326-6071
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-65">
                  <div className="w-12 h-12 rounded-full bg-pool-50 flex items-center justify-center text-pool-600 flex-shrink-0" data-id="element-66">
                    <Mail size={24} data-id="element-67" />
                  </div>
                  <div data-id="element-68">
                    <h4 className="font-bold text-navy-900 text-lg" data-id="element-69">Email</h4>
                    <a href="mailto:info@innovapools.com" className="text-gray-600 hover:text-pool-600 transition-colors text-lg" data-id="element-70">
                      info@innovapools.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-71">
                  <div className="w-12 h-12 rounded-full bg-pool-50 flex items-center justify-center text-pool-600 flex-shrink-0" data-id="element-72">
                    <MapPin size={24} data-id="element-73" />
                  </div>
                  <div data-id="element-74">
                    <h4 className="font-bold text-navy-900 text-lg" data-id="element-75">
                      Área de Servicio
                    </h4>
                    <p className="text-gray-600 text-lg" data-id="element-76">
                      Central Florida (Orlando, Kissimmee, Davenport, Winter
                      Garden y alrededores)
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Form */}
          <div className="w-full lg:w-7/12" data-id="element-77">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white p-8 md:p-10 rounded-3xl shadow-2xl border border-gray-100" data-id="element-78">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-79">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-80">
                  <div data-id="element-81">
                    <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-82">
                      Nombre Completo *
                    </label>
                    <input type="text" id="nombre" name="nombre" required className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-pool-500 focus:border-pool-500 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="Ej. Juan Pérez" data-id="element-83" />
                  </div>
                  <div data-id="element-84">
                    <label htmlFor="ciudad" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-85">
                      Email *
                    </label>
                    <input type="text" id="email" name="email" required className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-pool-500 focus:border-pool-500 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="Ej.innovapoolsystems@ " data-id="element-86" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-87">
                  <div data-id="element-88">
                    <label htmlFor="telefono" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-89">
                      Teléfono / WhatsApp *
                    </label>
                    <input type="tel" id="telefono" name="telefono" required className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-pool-500 focus:border-pool-500 outline-none transition-all bg-gray-50 focus:bg-white" placeholder="(407) 000-0000" data-id="element-90" />
                  </div>
                  <div data-id="element-91">
                    <label htmlFor="tipoServicio" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-92">
                      Tipo de Servicio *
                    </label>
                    <select id="tipoServicio" name="tipoServicio" required className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-pool-500 focus:border-pool-500 outline-none transition-all bg-gray-50 focus:bg-white" data-id="element-93">
                      <option value="" data-id="element-94">Seleccione una opción</option>
                      <option value="Remodelación" data-id="element-95">
                        Remodelación Completa
                      </option>
                      <option value="Reparación" data-id="element-96">
                        Diagnóstico y Reparación
                      </option>
                      <option value="Filtración" data-id="element-97">Sistemas de Filtración</option>
                      <option value="Automatización" data-id="element-98">Automatización</option>
                      <option value="Otro" data-id="element-99">Otro</option>
                    </select>
                  </div>
                </div>

                <div data-id="element-100">
                  <label htmlFor="ciudad" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-101">
                    Ciudad o Detalles (Opcional)
                  </label>
                  <textarea id="ciudad" name="ciudad" rows={4} className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-pool-500 focus:border-pool-500 outline-none transition-all bg-gray-50 focus:bg-white resize-none" placeholder="Cuéntenos un poco más sobre su proyecto..." data-id="element-102"></textarea>
                </div>

                <button type="submit" disabled={isSubmitting} className="w-full bg-gold-500 hover:bg-gold-600 text-white font-bold text-lg py-4 px-8 rounded-xl transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-103">
                  {isSubmitting ? <span className="flex items-center gap-2" data-id="element-104">
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-105">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-106"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-107"></path>
                      </svg>
                      Enviando...
                    </span> : <>
                      Solicite su Inspección Gratuita
                      <Send size={20} data-id="element-108" />
                    </>}
                </button>
                <p className="text-center text-xs text-gray-500 mt-4" data-id="element-109">
                  Al enviar este formulario, acepta ser contactado por Innova
                  Pools & Systems.
                </p>
              </form>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}